<section class="scan-order-success-container">
  <header class="header">
    <div role="button" class="close-btn-container">
      <img mat-dialog-close src="/assets/images/scan/close_icon.svg" alt="" />
    </div>
    <div class="success-img">
      @if (order.fulfillmentStatus === TranslatedFulfillmentStatus.PARTIALLY_FULFILLED) {
        <img src="/assets/images/scan/partial_icon.svg" alt="" />
      }
      @if (order.fulfillmentStatus !== TranslatedFulfillmentStatus.PARTIALLY_FULFILLED) {
        <img src="/assets/images/scan/success_icon.svg" alt="" />
      }
    </div>
    <div class="header__title" mat-dialog-title>
      <div>
        @switch (order.fulfillmentStatus) {
          @case ('fulfilled') {
            <div>Order is Fulfilled Successfully!</div>
          }
          @case ('partially_fulfilled') {
            <div>Order is Partially Fulfilled!</div>
          }
          @default {
            <div>Shipping label was scanned successfully!</div>
          }
        }
      </div>
    </div>
  </header>
  <div class="scan-order-success-content" fxFlex>
    <div class="scan-order-success-content__scroll">
      <div class="order-detail">
        <span class="order-detail__title">Batch Name: </span>
        <span class="order-detail__value">{{ order?.orderBatch.name }}</span>
      </div>
      <div class="order-detail">
        <span class="order-detail__title">Label#: </span>
        <span class="order-detail__value">{{ order.shippingId }}</span>
      </div>
      <div class="order-detail">
        <span class="order-detail__title">Order#: </span>
        <span class="order-detail__value"
          >{{ order.orderNumber }}
          @if (order.splitted) {
            <span>-{{ orderSplitIndicesText }}</span>
          }
        </span>
      </div>
      <div class="order-detail">
        <span class="order-detail__title">Number of Items: </span>
        <span class="order-detail__value">{{ order.itemCount }}</span>
      </div>
      <div class="order-detail__note">
        Notes
        <img mat-dialog-close src="/assets/icons/notes-customer.png" alt="" style="padding-left: 5px" />
        @if (order.note === '') {
          <p class="order-detail__note-font">There is no note on this order.</p>
        }
        <p class="order-detail__note-font">{{ order.note }}</p>
      </div>
      <div class="print-btn-action">
        <a class="print-btn">
          <div class="print-image">
            <img class="margin-left" src="../../../../../assets/images/print/print_icon.svg" alt="" />
            <span class="button-text"> Print </span>
          </div>
        </a>
      </div>
    </div>
  </div>

  <mat-divider class="divider"></mat-divider>

  <div class="scan-order-input">
    <app-scan-input-for-order-modal
      [modalType]="'order'"
      [placeholder]="'Insert barcode number'"
      [buttonChangeColor]="'blue'"
      [title]="'Scan the next order to fulfill it.'"
      [subtitle]="'or'">
    </app-scan-input-for-order-modal>
  </div>

  <div class="scan-order-success-actions" mat-dialog-actions fxFlex>
    <!--    <button-->
    <!--      class="scan-order-success-actions__btn"-->
    <!--      mat-flat-button-->
    <!--      color="primary"-->
    <!--      (click)="batchActionService.openPrintOrderWindow(order.id)"-->
    <!--    >-->
    <!--      <ng-container *ngIf="loader">-->
    <!--        <mat-spinner [diameter]="30" class="fulfill-spinner"></mat-spinner>-->
    <!--      </ng-container>-->
    <!--      <ng-container *ngIf="!loader">PRINT LABEL</ng-container>-->
    <!--    </button>-->

    @if (!nextScanOrder) {
      <button class="scan-order-success-actions__btn" mat-flat-button color="primary" (click)="scanOrder()">
        @if (loader) {
          <mat-spinner [diameter]="30" class="fulfill-spinner"></mat-spinner>
        }
        @if (!loader) {
          SCAN ORDER
        }
      </button>
    }

    @if (nextScanOrder) {
      <button class="scan-order-success-actions__btn" mat-flat-button color="primary" (click)="scannext(true)">
        @if (loader) {
          <mat-spinner [diameter]="30" class="fulfill-spinner"></mat-spinner>
        }
        @if (!loader) {
          NEXT ORDER
        }
      </button>
    }
  </div>
</section>
